"use client";
'use strict';

var React = require('react');

function assignRef(ref, value) {
    if (ref == null)
        return;
    if (typeof ref === 'function') {
        ref(value);
        return;
    }
    try {
        // @ts-ignore
        ref.current = value;
    }
    catch (error) {
        throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
}
/**
 * React hook that merges react refs into a single memoized function
 *
 * @example
 * ```javascript
 * const referenceRef = useMergedRef(elementRef, ref)
 * ```
 */
function useMergedRef(...refs) {
    return React.useMemo(() => {
        if (refs.every((ref) => ref == null)) {
            return null;
        }
        return (node) => {
            refs.forEach((ref) => {
                if (ref)
                    assignRef(ref, node);
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

exports.assignRef = assignRef;
exports.useMergedRef = useMergedRef;
//# sourceMappingURL=useMergedRef.js.map
